import AddToQuoteView from './views/add-to-quote.js';

export default class AddToQuote {
	constructor({
		el,
		product_id,
		quote,
		is_accessory,
		options_active
	}) {
		this.view = new AddToQuoteView({
			el: el,
			product_id: product_id,
			quote: quote,
			is_accessory: is_accessory,
			options_active: options_active
		});
	}
}